import React, { useState } from "react";
import { Modal, Box, Typography, Button } from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import InfinityCard from "./InfinityCard";
import CharacterCard from "./CharacterCard";
import FlipCard from "./CardFlip";
import backImage from "../@shared/assets/back-of-card.png";

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0,0,0,0.8)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1400,
};

const containerStyle = {
  width: 280,
  backgroundColor: "#1e1149",
  padding: 20,
  borderRadius: 16,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

const variants = {
  hidden: { scale: 0, opacity: 0 },
  visible: {
    scale: [1.2, 1],
    opacity: 1,
    transition: { times: [0, 1], duration: 0.6, ease: "easeOut" },
  },
  exit: { scale: 0, opacity: 0, transition: { duration: 0.3 } },
};

export default function CardRewardModal({ visible, reward, onClose }) {
  const [flipped, setFlipped] = useState(false);

  console.log("reward", reward);
  if (!reward?.reward) return null;

  const isCharacter =
    reward.reward.type === "character" || reward.reward.attackName;

  const isFinite =
    reward.reward.finite === true || reward.reward.finite === "TRUE";

  const handleButton = () => {
    if (flipped) {
      setFlipped(false);
      onClose();
    } else {
      setFlipped(true);
    }
  };

  return (
    <Modal open={visible} onClose={onClose} closeAfterTransition>
      <AnimatePresence>
        {visible && (
          <Box
            component={motion.div}
            initial="hidden"
            animate="visible"
            exit="exit"
            variants={variants}
            style={overlayStyle}
          >
            <Box style={containerStyle}>
              <Typography
                variant="h6"
                sx={{ color: "#fff", fontWeight: "bold", mb: 2 }}
              >
                You Received:
              </Typography>

              <FlipCard
                frontComponent={
                  isCharacter ? (
                    <CharacterCard
                      {...reward.reward}
                      heightPer={95}
                      containerHeight={350}
                    />
                  ) : (
                    <InfinityCard
                      {...reward.reward}
                      heightPer={95}
                      containerHeight={350}
                    />
                  )
                }
                backImage={backImage}
                flipped={flipped}
                setFlipped={setFlipped}
              />

              <Typography
                sx={{ color: "#fbcf57", fontSize: 18, fontWeight: 600, mt: 2 }}
              >
                {isCharacter
                  ? "Character Card"
                  : isFinite
                  ? "Finite Card"
                  : "Infinity Card"}
              </Typography>
              <Typography sx={{ color: "#fff", fontSize: 16, mb: 2 }}>
                x{reward.amount}
              </Typography>

              <Button
                variant="contained"
                onClick={handleButton}
                sx={{
                  mt: 1,
                  bgcolor: "#fbcf57",
                  color: "#1e1149",
                  fontWeight: "bold",
                  px: 3,
                  py: 1,
                  borderRadius: 1,
                  "&:hover": { bgcolor: "#e0b44c" },
                }}
              >
                {flipped ? "Continue" : "Flip"}
              </Button>
            </Box>
          </Box>
        )}
      </AnimatePresence>
    </Modal>
  );
}
